export enum SwapStep {
  LOADING,
  FORM,
  REVIEW_FORM,
  WAITING_SIGNATURE,
  VALIDATING_TRANSACTION,
  SWAPPED,
  INSUFFICIENT_GAS,
  UNKNOWN_ERROR,
  DEADLINE_EXCEEDED,
  REJECTED_BY_THE_USER,
}
